var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "nativewind/jsx-runtime";
import React, { useState, useCallback } from 'react';
import { Platform } from 'react-native';
import LocationConfirmBottomSheet from '@/modals/LocationConfirmBottomSheet';
import { showAppInstallPrompt } from '@/utils/appInstallPrompt';
import { getDistanceFromCurrentLocation as getDistanceMetersFromCurrentLocation } from '@/utils/LocationCheckUtils';
export default function useNavigateWithLocationCheck() {
    var _a, _b;
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalData, setModalData] = useState(null);
    const navigateWithLocationCheck = useCallback((_a) => __awaiter(this, [_a], void 0, function* ({ targetLocation, placeName, address, type, onNavigate, }) {
        // 웹: 대상(정보등록/리뷰 폼)은 모두 앱 전용이다. 이동하지 않고 여기서 막는다 —
        // 이동 후 라우트 게이트가 goBack 하는 방식은 폼의 나가기 확인 시트에 막혀
        // 계속 작성할 수 있었다(PlaceFormV2·BuildingFormV2).
        if (Platform.OS === 'web') {
            showAppInstallPrompt('이 기능은 앱에서만 이용할 수 있어요');
            return;
        }
        // 거리 체크
        const distance = yield getDistanceMetersFromCurrentLocation(targetLocation);
        if (distance !== undefined && distance <= 200) {
            // 200m 이내면 바로 navigate
            onNavigate();
        }
        else {
            // 200m 초과면 모달 표시
            setModalData({ placeName, address, type, onNavigate });
            setIsModalVisible(true);
        }
    }), []);
    const handleConfirm = useCallback(() => {
        setIsModalVisible(false);
        if (modalData) {
            modalData.onNavigate();
        }
        setModalData(null);
    }, [modalData]);
    const handleCancel = useCallback(() => {
        setIsModalVisible(false);
        setModalData(null);
    }, []);
    const LocationConfirmModal = (_jsx(LocationConfirmBottomSheet, { isVisible: isModalVisible, placeName: modalData === null || modalData === void 0 ? void 0 : modalData.placeName, address: (_a = modalData === null || modalData === void 0 ? void 0 : modalData.address) !== null && _a !== void 0 ? _a : '', type: (_b = modalData === null || modalData === void 0 ? void 0 : modalData.type) !== null && _b !== void 0 ? _b : 'place', onConfirm: handleConfirm, onCancel: handleCancel }));
    return {
        navigateWithLocationCheck,
        LocationConfirmModal,
    };
}
